import React, { useEffect } from 'react';
import { getAuth, EmailAuthProvider, GoogleAuthProvider } from 'firebase/auth';
import { StyledFirebaseAuth } from 'react-firebaseui';
import 'firebase/auth';
import './App.css';

export default function Welcome() {
    const auth = getAuth();
    

    const firebaseUIConfig = {
        signInOptions: [
      { 
        provider: EmailAuthProvider.PROVIDER_ID,
        requireDisplayName: true,
      },
      {
        provider: GoogleAuthProvider.PROVIDER_ID
      }
    ],
    signInFlow: 'popup',
    credentialHelper: 'none',
    callbacks: {
      signInSuccessWithAuthResult: () => {
        const customRedirectUrl = '/'; 
        window.location.href = customRedirectUrl;
    }
    }
    }

  useEffect(() => {
    const showLoginButton = document.querySelector('.show-login');
    const closeButton = document.querySelector('.popup .close-btn');
    const popup = document.querySelector(".popup");
    const header = document.querySelector("header");
    
    if (showLoginButton && closeButton && popup && header) {
      showLoginButton.addEventListener("click", function(){
        popup.classList.add("active");
        header.classList.add("active");
      });
    
      closeButton.addEventListener("click", function(){
        popup.classList.remove("active");
        header.classList.remove("active");
      });
    }
  }, []);

  return (
    <div>
        <main>
          <section>
            <header className="welcome">
              <h1>Welcome to Flow!</h1>
            </header>
          </section>

          <section>
            <div className="login-button">
              <button className="show-login">Login</button>
            </div>   
            <div className="popup">
              <div className="close-btn">×</div>
              <div className="login-form">
                <h2>Login</h2>
                <StyledFirebaseAuth uiConfig={firebaseUIConfig} firebaseAuth={auth} />
              </div>
            </div>
          </section>
        </main>
    </div>
  )
}
